<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="800px" style="opacity: 0.8;">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">{{title}}</div>
        <v-spacer>
        </v-spacer>
      </div>
      <VideoPlayer :src="video_src" v-if="devFunc"></VideoPlayer>
      <v-divider class="mt-3 mx-2"></v-divider>
    </v-card>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
// import Service from '../service/service'
import VideoPlayer from '../components/VideoPlayer.vue'
export default {
  components:{VideoPlayer},
  name: 'Dashboard',
  data: () => ({
    devFunc: false,
    video_src: '',
    title: 'Dashboard',
    controlPermission: [],
    rules: {
      content: [v => !!v || 'Required']
    },
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.$emit('setAppbar', { isHide: false })
    if (this.devFunc) {
      this.video_src = 'http://172.16.40.134:8585/Config/playback/hls/HcotxIdQUriLYVJR.m3u8'
    }
  },
  watch: {
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
  },
  created: function () {
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
  }
}
</script>
